import { DetalleDocumentosOficialesService } from './detalle-documentos-oficiales.service';
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { DocumentosOficialesService } from '../documentos-oficiales/documentos-oficiales.service';

@Injectable({ providedIn: 'root' })
export class DetalleDocumentosResolver implements Resolve<any> {

    constructor(
        private documentoOficialesService:DocumentosOficialesService,
        private detalleDocumentosOficialesService:DetalleDocumentosOficialesService
    ){}
    resolve(route: ActivatedRouteSnapshot): Observable<any> {
        const documento_uuid = route.paramMap.get('documento_uuid');
        return forkJoin([
            this.documentoOficialesService.getElementosVinculados(documento_uuid),
            this.documentoOficialesService.getBitacoraBienesDocumentos(documento_uuid),
            this.detalleDocumentosOficialesService.getListaDocumentoOficial(documento_uuid)
        ])
    }
}